import { Globe } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center space-x-2">
      <Globe size={18} className="text-gray-400" />
      <div className="flex items-center bg-gray-800 rounded-lg p-1">
        <button
          onClick={() => setLanguage('en')}
          className={`px-3 py-1 text-sm font-medium rounded  ${
            language === 'en'
              ? 'bg-[#B91C1C] text-white'
              : 'text-gray-400 hover:text-white'
          }`}
        >
          EN
        </button>
        <button
          onClick={() => setLanguage('es')}
          className={`px-3 py-1 text-sm font-medium rounded  ${
            language === 'es'
              ? 'bg-[#B91C1C] text-white'
              : 'text-gray-400 hover:text-white'
          }`}
        >
          ES
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;